import React from "react";
import { useTranslation } from "react-i18next";
const Flags = () => {
  const { t } = useTranslation();

  const country_codes = ["ar", "cl", "br", "mx", "es", "us", "co", "au"];
  const flags = country_codes.map((code) => {
    return {
      code: code,
      label: t(`countries.${code}`),
      image: `https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/icons/${code}.svg`,
    };
  });

  return (
    <div class="mt-[18px] flex gap-x-4 gap-y-4 sm:gap-x-3 lg:gap-x-8 flex-wrap max-w-[356px] text-sm sm:max-w-[834px] xl:max-w-[1366px] mx-auto lg:mx-0 text-text-alternative">
      {flags.map((flag, index) => (
        <div key={index} className="flex items-center">
          <img className="mr-2" src={flag.image} alt={flag.label} />
          {flag.label}
        </div>
      ))}
    </div>
  );
};

export default Flags;
